// extracted by mini-css-extract-plugin
export default {"iconBox":"P7AEsTAREFNsXZ4MMGJD","infoBox":"jyZP2cvws6sAKlfZg6Db","allowsTitle":"GSte1KsCrZHR_YD7iS_y","allowsList":"p6oRsvdMNchHdgA8NfRh","allowsItem":"LIq8Qepyn4KTAiTDG79I"};